import React, {useState} from 'react';
import PropTypes from 'prop-types';
import FormGroupRowText from "../Elements/FormGroupRowText";
import {Col, Row} from "reactstrap";
import {withRefresh} from "../Elements/Fetch";
import FormWithActions from "../Elements/FormWithActions/FormWithActions";
import {validEmail} from "../services";
import FormGroupRowCheckbox from "../Elements/FormGroupRowCheckbox";

const SenderOnboardingEditForm = ({senderOnboarding, onSubmit}) => {
    const {
        requestId,
        email: defaultEmail,
        contactPersonFirstName: defaultContactPersonFirstName,
        contactPerson: defaultContactPerson,
        contactPhone: defaultContactPhone,
        partnerName: defaultPartnerName,
        askUbo: defaultAskUbo,
    } = senderOnboarding;

    const [email, setEmail] = useState(defaultEmail || '');
    const [contactPersonFirstName, setContactPersonFirstName] = useState(defaultContactPersonFirstName || '');
    const [contactPerson, setContactPerson] = useState(defaultContactPerson || '');
    const [contactPhone, setContactPhone] = useState(defaultContactPhone || '');
    const [partnerName, setPartnerName] = useState(defaultPartnerName || '');
    const [askUbo, setAskUbo] = useState(defaultAskUbo || false);

    const handleAction = () => onSubmit({
        email,
        contactPersonFirstName,
        contactPerson,
        contactPhone,
        partnerName,
        askUbo,
    });

    let disableSubmitReason = '';
    if (!validEmail(email)) {
        disableSubmitReason = 'The e-mail needs to be valid.';
    }

    return (
        <>
            <Row>
                <Col>
                    <h1 className="mb-5">
                        SenderOnboarding: {requestId}
                    </h1>
                </Col>
            </Row>
            <FormWithActions onAction={handleAction} disableSubmitReason={disableSubmitReason}>
                <FormGroupRowText
                    label="Contact e-mail"
                    placeholder="Contact e-mail"
                    type="text"
                    value={email}
                    onChange={setEmail}
                />
                <FormGroupRowText
                    label="Contact first name"
                    placeholder="Contact name"
                    type="text"
                    value={contactPersonFirstName}
                    onChange={setContactPersonFirstName}
                />
                <FormGroupRowText
                    label="Contact last name"
                    placeholder="Contact last name"
                    type="text"
                    value={contactPerson}
                    onChange={setContactPerson}
                />
                <FormGroupRowText
                    label="Contact phone"
                    placeholder="Contact phone"
                    type="text"
                    value={contactPhone}
                    onChange={setContactPhone}
                />
                <FormGroupRowCheckbox
                    label="Ask UBO"
                    checked={askUbo}
                    onChange={setAskUbo}
                />
                <FormGroupRowText
                    label="Partner Name"
                    placeholder="Partner Name"
                    type="text"
                    value={partnerName}
                    onChange={setPartnerName}
                />
            </FormWithActions>
        </>
    );
};

SenderOnboardingEditForm.propTypes = {
    senderOnboarding: PropTypes.shape({
        id: PropTypes.number.isRequired,
        requestId: PropTypes.string.isRequired,
    }).isRequired,
    onSubmit: PropTypes.func.isRequired,
};

export default withRefresh(SenderOnboardingEditForm);
